import type { WaitListRegistration } from '@/@types/client-api';

type WaitlistRegistrationSource =
  | WaitListRegistration[]
  | Record<string, unknown>
  | null
  | undefined;

const getWaitlistItemCode = (registration: Record<string, unknown>): string | undefined => {
  const rawCode =
    registration.item_PK ??
    registration.Item_PK ??
    registration.itemPk ??
    registration.itemPK ??
    registration.ItemPk ??
    registration.ItemPK ??
    registration.pk ??
    registration.PK;

  if (rawCode == null) return undefined;

  const code = String(rawCode).trim();
  return code || undefined;
};

const toRegistrationList = (
  waitlistRegistrations: WaitlistRegistrationSource
): Array<Record<string, unknown>> => {
  if (!waitlistRegistrations) return [];

  if (Array.isArray(waitlistRegistrations)) {
    return waitlistRegistrations.filter(
      (registration): registration is Record<string, unknown> =>
        !!registration && typeof registration === 'object'
    );
  }

  return Object.values(waitlistRegistrations).filter(
    (registration): registration is Record<string, unknown> =>
      !!registration && typeof registration === 'object'
  );
};

export const getWaitlistRegistrationCodes = (
  waitlistRegistrations?: WaitlistRegistrationSource
): Set<string> => {
  const codes = new Set<string>();

  toRegistrationList(waitlistRegistrations).forEach(waitlistRegistration => {
    const code = getWaitlistItemCode(waitlistRegistration);
    if (code) codes.add(code);
  });

  return codes;
};
